/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import { Controller, useFormContext } from "react-hook-form";
import * as MUI from "@mui/material";

import { FiEye, FiEyeOff } from "react-icons/fi";

interface FormInputProps {
  name: string | any;
  label?: string;
}

interface StatePassword {
  name: string | any;
  label?: string;
  type: string;
  handleClickShowPassword(): void;
  handleMouseDownPassword(): void;
}

type Options = {
  key?: string;
  value: string;
  label: string;
};

interface FormInputSelectProps {
  name: string | any;
  label: string;
  items: Options[];
}

export const FormInputText = ({ name, label }: FormInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({
        field: { onChange, value, onBlur },
        fieldState: { error },
      }) => (
        <MUI.TextField
          helperText={error ? error.message : ""}
          error={!!error}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          fullWidth
          type="text"
          label={label}
          variant="outlined"
        />
      )}
    />
  );
};

export const FormInputPassword = ({
  name,
  label,
  handleClickShowPassword,
  handleMouseDownPassword,
  type,
}: StatePassword) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({
        field: { onChange, value, onBlur },
        fieldState: { error },
      }) => (
        <MUI.TextField
          helperText={error ? error.message : ""}
          error={!!error}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          fullWidth
          type={type}
          label={label}
          variant="outlined"
          InputProps={{
            endAdornment: (
              <MUI.IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {value.showPassword ? (
                  <FiEyeOff size={20} />
                ) : (
                  <FiEye size={20} />
                )}
              </MUI.IconButton>
            ),
          }}
        />
      )}
    />
  );
};

export const FormInputSelect = ({
  name,
  label,
  items,
}: FormInputSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      // defaultValue=""
      render={({
        field: { onChange, value, onBlur },
        fieldState: { error },
      }) => (
        <MUI.FormControl>
          <MUI.InputLabel>{label}</MUI.InputLabel>
          <MUI.Select
            error={!!error}
            onChange={onChange}
            onBlur={onBlur}
            value={value || ""}
            fullWidth
            label={label}
          >
            {items.map((option) => (
              <MUI.MenuItem key={option.key} value={option.value}>
                {option.label}
              </MUI.MenuItem>
            ))}
          </MUI.Select>
          <MUI.FormHelperText
            sx={{
              color: "#d32f2f",
            }}
          >
            {error?.message}
          </MUI.FormHelperText>
        </MUI.FormControl>
      )}
    />
  );
};
